import config from "@/config";
import http from "@/utils/request";

export default {
    list: {
      url: `${config.API_URL}/api/ly/distributor/page`,
      name: "分销商列表",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
    status: {
      url: `${config.API_URL}/api/ly/distributor/updateStatus`,
      name: "权限设置",
      post: async function (data = {}, config = {}) {
        return await http.post(this.url, data, config);
      },
    },
    remark: {
      url: `${config.API_URL}/api/ly/distributor/updateRemark`,
      name: "设置备注",
      post: async function (data = {}, config = {}) {
        return await http.post(this.url, data, config);
      },
    },
    log: {
      url: `${config.API_URL}/api/ly/distributor/log`,
      name: "日志",
      get: async function (data = {}) {
        return await http.get(`${this.url}/${data}`);
      },
    },
    treeList: {
      url: `${config.API_URL}/api/ly/distributor/tree`,
      name: "分销商关系树形图",
      get: async function (data = {}, config = {}) {
        return await http.get(this.url, data, config);
      },
    },
};
